<template>
    <div>
        <ul :class="classNames">
            <li v-for="item in data" :key="item.id" @click="select(item)" :class="[classNames+'_li', {[classNames+ '_li_active']: value === item.id && item.status == 2, [classNames+ '_li_disabled']: !statusColor[item.status].canClk || isFzb(item)}]">
                <div :class="classNames+ '_li_top'">
                    <div :class="classNames+ '_li_status'">
                        <span>{{item.account_name}}</span>
                        <span v-statusColor="statusColor[item.status] || { title: '审核失败',
                        color: '#EA4B4B'}">审核失败</span>
                    </div>
                    <div class="detail-text" @click.stop="showDetailFn(item)">
                        详情 >
                    </div>
                    <div :class="classNames+ '_li_account'">
                        {{item.account | handleAccount(item.account_type)}}
                    </div>
                    <div :class="classNames+ '_li_name'">
                        {{item.name}}
                    </div>
                    <div :class="classNames+ '_li_cover'" v-if="isFzb(item)">支付宝账户不支持提现，请更换银行卡提现</div>
                    <!-- <div :class="classNames+ '_li_cover'" v-else-if="item.status == 3">{{item.error_msg || '审核失败'}} </div> -->
                </div>
                <div :class="classNames+ '_li_bottom'">
                    <p @click.stop="deleteAccount(item)">删除</p>
                </div>
            </li>
            <li style="width: calc(33% - 6px);" v-for="(item, index) in nums" :key="index"></li>
        </ul>
        <accountDetailPop v-model="accountDetailPopObj.showPop" :id="accountDetailPopObj.id" @toValidate="toValidate"></accountDetailPop>
        <validateQrcodePop @input="onValidateQrcodePopChange" v-model="validateQrcodePopObj.showPop" :imgUrl="validateQrcodePopObj.imgUrl"></validateQrcodePop>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import validateQrcodePop from './components/validateQrcodePop.vue'
import accountDetailPop from './components/accountDetailPop.vue'
import { accountList_statusColorObj } from './data.js'

export default {
    components: {
        validateQrcodePop,
        accountDetailPop
    },
    props: {
        data: { // 提现账户列表
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number],
            default: ''
        }
    },
    directives: {
        statusColor: {
            bind(el, binding) {
                el.style.color=binding.value.color
                el.innerText = binding.value.title
            },
            update(el, binding) {
                el.style.color=binding.value.color
                el.innerText = binding.value.title
            }
        }
    },
    data() {
        return {
            classNames: 'account_list',
            statusColor: accountList_statusColorObj,
            validateQrcodePopObj: {
                showPop: false,
                imgUrl: ''
            },
            accountDetailPopObj: { // 账户详情弹窗相关
                showPop: false,
                id: ''
            }
        }
    },
    computed: {
        nums() {
            return this.data.length ? 3 - this.data.length % 3 : 0
        } 
    },
    methods: {
        ...mapActions('withdrawal',['getValidateQrcodeAPI']),
        // 点击‘详情’
        showDetailFn(item){
            let { id } = item
            this.accountDetailPopObj.id = id
            this.accountDetailPopObj.showPop = true
        },
        // 监听验证弹窗关闭
        onValidateQrcodePopChange(e){
            if(!e){
                this.$emit('needRefresh')
            }
        },
        // 是支付宝
        isFzb(item){
            let {account_type} = item
            if(account_type==1){
               return true
            }else{
                return false
            }
        },
        // 监听-点击验证
        async toValidate(e){
            // console.log('toValidate-e:',e)
            let { account_id, merchant_log_id } = e
            let res = await this.getValidateQrcodeAPI({
                account_id,
                log_id: merchant_log_id
            })
            setTimeout(()=>{
                this.accountDetailPopObj.showPop = false
            },10)// 修改点击验证弹窗闪烁问题
            this.validateQrcodePopObj.imgUrl = res.qrcode
            this.validateQrcodePopObj.showPop = true
        },
        select(item) {
            let {status, id} = item
            if(this.statusColor[status].needValidate){ // 点击验证
                this.showDetailFn(item)
                return
            }
            if(status == 2 && !this.isFzb(item)) {
                this.$emit('input', item.id)
            }
        },
        deleteAccount(item) {
            this.$emit('deleteAccount', item)
        }
    },
    filters: {
        handleAccount(value, type) {
            if(type == 1) {
                return value.slice(0, 3) + '****' + value.slice(7, value.length)
            } else {
                let str = new Array(value.length - 4).fill('*').join('')
               return  str + value.slice(value.length - 4, value.length)
            }
        }
    }
}
</script>
<style lang="less" scoped>
    @classNames: account_list;
    .@{classNames} {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
            list-style: none;
        }
        .@{classNames}_li {
            flex-shrink: 0;
            width: calc(33% - 6px);
            height: 181px;
            background: #FFFFFF;
            box-shadow: 0px 8px 24px 0px rgba(18, 38, 63, 0.03);
            border-radius: 8px;
            border: 1px solid #D7D7D7;
            margin-top: 12px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            cursor: pointer;
            &.@{classNames}_li_disabled {
                cursor: not-allowed;
            }
            &.@{classNames}_li_active {
                box-shadow: 0px 14px 24px 0px rgba(18, 38, 63, 0.06), 0px 3px 14px 0px rgba(18, 38, 63, 0.09);
                border: 3px solid #4E70F2;
            }
            .@{classNames}_li_top {
                padding: 20px;
                border-bottom: 1px solid #EBEEF5;
                flex: 1 0 auto;
				position: relative;
                .@{classNames}_li_status {
                    display: flex;
                    justify-content: space-between;
                    font-size: 16px;
                    line-height: 16px;
                }
                .detail-text{
                    position: absolute;
                    right: 20px;
                    top: 40px;
                    cursor: pointer;
                    color: #808080;
                    &:hover{
                        color: #000;
                    }
                }
                .@{classNames}_li_account {
                    font-size: 16px;
                    color: #000000;
                    line-height: 16px;
                    margin-top:20px;
                }
                .@{classNames}_li_name {
                    font-size: 16px;
                    line-height: 16px;
                    color: #606266;
                    margin-top:20px;
                }
				.@{classNames}_li_cover{
					width: 100%;
					height: 100%;
					color: #fff;
					display: flex;
					justify-content: center;
					align-items: center;
					background-color: rgba(0, 0, 0, 0.6);
					position: absolute;
					top: 0;
					left: 0;
				}
            }
            .@{classNames}_li_bottom {
                padding:6px 20px;
                flex-shrink: 0;
                box-sizing: border-box;
                p {
                    float: right;
                    width: 95px;
                    height: 25px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    border: 1px solid #4E70F2;
                    text-align: center;
                    line-height: 25px;
                    color: #4E70F2;
                    cursor: pointer;
                }
            }
        }
    }
</style>